import type { FC } from 'react';
import React from 'react';
import { IconButton, Input, InputAdornment, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import clsx from 'clsx';
import useStyles from '../styles.ts';

import { useTranslation } from 'react-i18next';
import type { I18nScenarioSectionNs } from '@/i18n/dictionaries/interfaces.ts';
import { I18nNamespace } from '@/i18n/types/i18nNamespace.ts';

export interface searchScenarioProps {
  search: (newVal: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const SearchScenario: FC<searchScenarioProps> = ({ search }) => {
  const classes = useStyles();
  const [translate] = useTranslation(I18nNamespace.ScenarioSection);
  return (
    (<FormControl
      variant="standard"
      className={clsx(classes.margin, classes.textField, classes.white)}>
      <Input
        onChange={search}
        id="standard-adornment-weight"
        placeholder={translate(nameof.full<I18nScenarioSectionNs>((l) => l.search))}    
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="toggle visibility" size="large">
              <SearchIcon/>
            </IconButton>
          </InputAdornment>
        }
        aria-describedby="standard-weight-helper-text"
        inputProps={{
          'aria-label': 'weight'
        }}
      />
    </FormControl>)
  );
};
export default SearchScenario;
